import React from 'react';
import PropTypes from 'prop-types';
import css from './SearchOption.scss';
import { getColorFromImage, defaultVibrantColor } from 'utils/colors';

export default class SearchOption extends React.Component {

  constructor() {
    super();
    this.state = { vibrantColor: defaultVibrantColor };
  }

  componentDidMount() {
    getColorFromImage(this.props.imageURL)
      .then(vibrantColor => this.setState({vibrantColor}))
      .catch(e => {}); // eslint-disable-line no-unused-vars
  }

  get avatarStyle() {
    return { border: `1px solid ${this.state.vibrantColor}`, backgroundImage: `url(${this.props.imageURL})` };
  }

  render() {
    return (
      <div className={css['container']}>
        <div style={this.avatarStyle} />
        <div className={css['option']}>
          <div className={css['title']}>{this.props.title}</div>
          <div className={css['description']}>{this.props.description || ''}</div>
        </div>
      </div>
    );
  }
}

SearchOption.propTypes = {
  imageURL: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string
};
